// Store id ↔ `.placed-module` element, filled by PlacedModule's ref (05b; its own file
// since 05d so the shell actions and the selection can both use it without an import
// cycle). No data-* attribute on purpose: the DOM stays identical to main.js's.

const elementsById = new Map<string, HTMLElement>();
const idsByElement = new WeakMap<HTMLElement, string>();

export function registerModuleElement(id: string, el: HTMLElement | null): void {
  if (el) {
    elementsById.set(id, el);
    idsByElement.set(el, id);
  } else {
    elementsById.delete(id);
  }
}

/** A live module element's store id; undefined once it's gone from the canvas. */
export function moduleIdOf(mod: HTMLElement): string | undefined {
  const id = idsByElement.get(mod);
  return id !== undefined && elementsById.get(id) === mod ? id : undefined;
}

/** The element React rendered for a store id, if it's on the canvas. */
export function moduleElementOf(id: string): HTMLElement | undefined {
  return elementsById.get(id);
}
